import { ErrorPageBase } from '@/pages/ErrorPage';
import { HttpService } from '@/features/api/http.service';

export default function SignedOutPage({ returnUrl }: { returnUrl?: string }) {
  return (
    <ErrorPageBase
      code={401}
      title="Signed out"
      description="You are signed out. To continue, sign back in."
      action={{ label: 'Sign back in', onClick: () => HttpService.getSession(returnUrl) }}
    />
  );
}
